export const iconFontAwesomeCommunicationIcons = (
	<i className="fa-solid fa-icons"></i>
);
